import { ArrowRight, Inbox, SlidersHorizontal } from "lucide-react";
import { cn } from "@/lib/utils";

export function PageHeader({ eyebrow, title, subtitle, meta, actions, children }) {
  return (
    <section className="hx-page-header">
      <div className="min-w-0">
        {eyebrow && <div className="hx-eyebrow mb-1">{eyebrow}</div>}
        <div className="flex flex-wrap items-center gap-2">
          <h1>{title}</h1>
          {meta}
        </div>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {(actions || children) && (
        <div className="hx-page-header-actions">
          {actions || children}
        </div>
      )}
    </section>
  );
}

export function MetricStrip({ metrics = [], columns = "auto" }) {
  return (
    <section className={cn("hx-metric-strip", columns === "wide" && "is-wide")}>
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <button
            key={metric.label}
            type="button"
            disabled={!metric.onClick}
            onClick={metric.onClick}
            className={cn("hx-metric", metric.tone && `tone-${metric.tone}`, metric.onClick && "is-clickable")}
          >
            <div>
              <span>{metric.label}</span>
              <strong>{metric.value}</strong>
              {metric.hint && <small>{metric.hint}</small>}
            </div>
            {Icon && (
              <div className="hx-metric-icon">
                <Icon size={17} strokeWidth={2} />
              </div>
            )}
          </button>
        );
      })}
    </section>
  );
}

export function CommandBar({ title = "Controls", children, actions, className }) {
  return (
    <section className={cn("hx-command-bar", className)}>
      <div className="hx-command-bar-title">
        <SlidersHorizontal size={15} />
        <span>{title}</span>
      </div>
      <div className="hx-command-bar-controls">{children}</div>
      {actions && <div className="hx-command-bar-actions">{actions}</div>}
    </section>
  );
}

export function DataPanel({ title, subtitle, actions, children, className }) {
  return (
    <section className={cn("hx-data-panel", className)}>
      {(title || subtitle || actions) && (
        <header>
          <div>
            {title && <h2>{title}</h2>}
            {subtitle && <p>{subtitle}</p>}
          </div>
          {actions && <div className="hx-data-panel-actions">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
}

export function Surface({ children, className, ...props }) {
  return <section className={cn("hx-surface", className)} {...props}>{children}</section>;
}

export function TableSurface({ children, empty, className }) {
  return (
    <div className={cn("hx-table-surface", className)}>
      {empty || children}
    </div>
  );
}

export function EmptyState({ title = "No records found", description, action }) {
  return (
    <div className="hx-empty-state">
      <div className="hx-empty-state-icon"><Inbox size={20} /></div>
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}

export function StatusPill({ children, tone = "slate" }) {
  return <span className={cn("hx-status-pill", `tone-${tone}`)}>{children}</span>;
}

export function InlineAction({ children, onClick }) {
  return (
    <button type="button" onClick={onClick} className="hx-inline-action">
      {children} <ArrowRight size={12} />
    </button>
  );
}

export function MoneyCell({ value }) {
  return <span className="hx-money-cell">{value}</span>;
}

export function DateCell({ children }) {
  return <span className="hx-date-cell">{children}</span>;
}
